<template>
  <div class="flex-col gap-y-md">
    <PackagesComponent
        v-if="activePackages.length > 0"
        :packages="activePackages"
        :customer-id="customerId"/>

    <PoliciesComponent
        v-if="policies.length > 0"
        :customer-id="customerId"/>

    <PackagesComponent
        v-if="inactivePackages.length > 0"
        :packages="inactivePackages"
        :customer-id="customerId"/>

    <NotFound
        v-else-if="!loading"
        :no-packages="inactivePackages.length === 0 && activePackages.length === 0"
        :no-policies="policies.length === 0"
        :filter-active="policiesFilterActive || packagesFilterActive"
    />

    <skeleton-results v-if="loading"/>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import PackagesComponent from './PackagesComponent.vue';
import PoliciesComponent from './PoliciesComponent.vue';
import NotFound from './NotFound.vue';
import SkeletonResults from './SkeletonResults.vue';

export default {
  name: "PackagesAndPolicies",
  components: {
    PackagesComponent,
    NotFound,
    PoliciesComponent,
    SkeletonResults,
  },
  props: {
    customerId: Number,
  },
  methods: {
    ...mapActions(`$_policy_page`, {
      getPolicyPageForCustomer: 'getPolicyPageForCustomer',}),
  },
  computed: {
    ...mapGetters(`$_policy_page`, {
      policies: 'policies',
      activePackages: 'activePackages',
      inactivePackages: 'inactivePackages',
      packagesFilterActive: 'packagesFilterActive',
      policiesFilterActive: 'policiesFilterActive',
    }),
    ...mapState(`$_policy_page`, {
      loading: 'loading',
    }),
  },
 created() {
    this.getPolicyPageForCustomer(this.customerId);
 }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
